import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'I changed my mind',
    cta: 'Confirm sending',
    description:
      'You have just made a transfer of the same amount for this same beneficiary. Do you confirm this new transfer?',
    title: 'Validation required',
  },
  fr: {
    cancel: 'J’ai changé d’avis',
    cta: 'Confirmer l’envoi',
    description:
      'Vous venez d’effectuer un virement du même montant pour ce même bénéficiaire. Confirmez-vous ce nouveau virement ?',
    title: 'Validation nécessaire',
  },
} as const);

export default locales;
